export const extractSubscriptionFromAuthPayload = (payload) => {
  const fallback = { subscription: null, plan: null };
  if (!payload) {
    return fallback;
  }

  const resolvedPayload =
    payload?.data && (payload.data.token || payload.data.lawyer)
      ? payload.data
      : payload;

  const candidateLawyers = [];

  if (resolvedPayload?.lawyer) {
    candidateLawyers.push(resolvedPayload.lawyer);
  }

  if (Array.isArray(resolvedPayload?.team_data)) {
    resolvedPayload.team_data.forEach((teamMember) => {
      if (teamMember?.lawyer) {
        candidateLawyers.push(teamMember.lawyer);
      }
    });
  }

  const owningLawyer = candidateLawyers.find(
    (lawyer) => lawyer?.subscription_usages?.subscription
  );

  if (!owningLawyer) {
    return fallback;
  }

  const subscription = owningLawyer.subscription_usages.subscription;
  const plan =
    subscription?.plan ||
    subscription?.plan_details ||
    subscription?.subscription_plan ||
    subscription?.current_plan ||
    owningLawyer.subscription_usages.plan ||
    null;

  return { subscription, plan };
};
